import { useTranslation } from "react-i18next";

/** The "Back" link above every onboarding step. */
export function BackLink({ onClick }: { onClick: () => void }) {
	const { t } = useTranslation();
	return (
		<button
			type="button"
			onClick={onClick}
			className="mb-6 flex items-center gap-2 font-body text-sm text-dashboard-muted transition-colors duration-200 hover:text-dashboard-text"
		>
			<svg
				className="h-4 w-4"
				fill="none"
				viewBox="0 0 24 24"
				stroke="currentColor"
				aria-hidden="true"
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth={2}
					d="M10 19l-7-7m0 0l7-7m-7 7h18"
				/>
			</svg>
			{t("common.back")}
		</button>
	);
}
